import { render, staticRenderFns } from "./startWorkList.vue?vue&type=template&id=98f5290e&scoped=true"
import script from "./startWorkList.vue?vue&type=script&lang=js"
export * from "./startWorkList.vue?vue&type=script&lang=js"
import style0 from "./startWorkList.vue?vue&type=style&index=0&id=98f5290e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f5290e",
  null
  
)

export default component.exports